import { useLang, type Lang } from '../i18n';

interface LangSwitchProps {
  variant?: 'default' | 'compact';
}

const options: { value: Lang; label: string }[] = [
  { value: 'en', label: 'EN' },
  { value: 'zh', label: '中' },
];

export default function LangSwitch({ variant = 'default' }: LangSwitchProps) {
  const { lang, setLang } = useLang();
  const isCompact = variant === 'compact';

  return (
    <div
      role="group"
      aria-label="language"
      className={
        isCompact
          ? 'inline-flex items-center gap-0 rounded-full border border-neutral-200 bg-white p-0.5 text-[11px] font-mono shadow-soft'
          : 'inline-flex items-center gap-0 rounded-full border border-neutral-200 bg-white p-0.5 text-xs font-mono shadow-soft'
      }
    >
      {options.map((opt) => {
        const active = opt.value === lang;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => setLang(opt.value)}
            aria-pressed={active}
            className={[
              isCompact ? 'px-2 py-0.5' : 'px-2.5 py-1',
              'rounded-full transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950/15',
              active
                ? 'bg-tan text-neutral-100 shadow-sm'
                : 'text-coffee hover:bg-neutral-100 hover:text-cocoa',
            ].join(' ')}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
